import React from 'react';
import Toast from './Toast';
import { ToastProvider, useToast } from './ToastProvider';

// Global toast instance for compatibility
let toastInstance = null;

// Component to capture toast instance
const ToastManager = () => {
  const toast = useToast();
  toastInstance = toast;
  return null;
};

// Wrap the provider to include our manager
const EnhancedToastProvider = ({ children }) => {
  return (
    <ToastProvider>
      <ToastManager />
      {children}
    </ToastProvider>
  );
};

// Compatibility API
const ToastCompat = {
  show: ({
    type = 'info',
    text1,
    text2,
    visibilityTime = 3000,
    position = 'bottom',
    bottomOffset,
    ...props
  }) => {
    if (!toastInstance) {
      console.warn('Toast is not initialized. Make sure ToastProvider is mounted.');
      return;
    }

    // Map old toast types to new variants
    const variantMap = {
      success: 'success',
      error: 'destructive',
      info: 'info',
    };

    toastInstance.toast({
      title: text1,
      description: text2 || text1 || '',
      variant: variantMap[type] || 'default',
    });
  },
};

export { Toast, EnhancedToastProvider as ToastProvider, useToast };
export default ToastCompat; 